/**
 * History Actions Component
 * Action buttons for scorecard history rows
 */

import { Button, Flex, Icon } from '@chakra-ui/react';
import { Eye } from '@kula-ai/icons/outline/Eye';
import { ScorecardItem } from '../types';

interface HistoryActionsProps {
  scorecard: ScorecardItem;
  onViewScorecard: (scorecard: ScorecardItem) => void;
}

export const HistoryActions = ({
  scorecard,
  onViewScorecard,
}: HistoryActionsProps) => {
  // Update: this is not needed anymore as we just show the scorecards whatever the backend returns
  // if (!scorecard.can_view_scorecard) {
  //   return null;
  // }

  return (
    <Flex justifyContent="flex-start" flex="1">
      <Button
        variant="quaternary"
        leftIcon={<Icon as={Eye} w="14px" h="14px" />}
        onClick={() => onViewScorecard(scorecard)}
        size="sm"
      >
        View
      </Button>
    </Flex>
  );
};
